export default __webpack_public_path__ + "static/media/william_diaz.a424e77e.jpg";